import { useCallback, useEffect, useState } from 'react';

import { getServiceFeeEligibility, postServiceFeeEligibility } from 'Services/privateApis';

type UseServiceFeeEligibilityProps = {
  dpEnquiryId?: number;
  enabled?: boolean;
};

type UseServiceFeeEligibilityReturn = {
  isEligibilityLoading: boolean;
  isEnquiryEligibleForServiceFee: boolean;
  setEligibility: () => void;
};

export const useServiceFeeEligibility = ({
  dpEnquiryId,
  enabled = false,
}: UseServiceFeeEligibilityProps = {}): UseServiceFeeEligibilityReturn => {
  const [isEnquiryEligibleForServiceFee, setIsEnquiryEligibleForServiceFee] = useState(false);
  const [isEligibilityLoading, setIsEligibilityLoading] = useState(enabled && Boolean(dpEnquiryId));

  useEffect(() => {
    if (!enabled || !dpEnquiryId) {
      setIsEligibilityLoading(false);
      return;
    }

    setIsEligibilityLoading(true);

    getServiceFeeEligibility(dpEnquiryId)
      .then((response: { eligible?: boolean }) => {
        setIsEnquiryEligibleForServiceFee(Boolean(response?.eligible));
      })
      .catch(() => {
        setIsEnquiryEligibleForServiceFee(false);
      })
      .finally(() => {
        setIsEligibilityLoading(false);
      });
  }, [enabled, dpEnquiryId]);

  const setEligibility = useCallback(() => {
    if (!dpEnquiryId) {
      return;
    }

    postServiceFeeEligibility(dpEnquiryId).catch(() => {});
  }, [dpEnquiryId]);

  return { isEligibilityLoading, isEnquiryEligibleForServiceFee, setEligibility };
};
